// src/screens/superadmin/faqs/FAQs.jsx
import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { Col, Row } from "react-bootstrap";
import {
  FaCheckCircle,
  FaPlus,
  FaQuestionCircle,
  FaSearch,
  FaTimes,
  FaTimesCircle,
} from "react-icons/fa";
import axios from "axios";
import Swal from "sweetalert2";
import "../../../assets/css/admin/faqs/FAQs.css";
import ActionDropdown from "../../../components/admin/dropdown/action/ActionDropdown";
import StatCard from "../../../components/admin/statcard/StatCard";
import Button from "../../../components/general/button/Button";
import Pagination from "../../../components/general/pagination/Pagination";
import AdminLayout from "../../../layouts/AdminLayout";
import MyContext from "../../../context/MyContext.js";
import { FAQsSkeleton } from "../../../components/general/skeleton/SkeletonBlock";

const FAQs = () => {
  const navigate = useNavigate();
  const { baseUrl, authToken } = useContext(MyContext);

  // ── Modal states ──
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);
  const [selectedFAQ, setSelectedFAQ] = useState(null);
  const [isEditing, setIsEditing] = useState(false);

  // ── Pagination & Search ──
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [searchTerm, setSearchTerm] = useState("");

  // ── Loading state — SubAdmins wali tarah ──
  const [loading, setLoading] = useState(false);

  // ── List ──
  const [faqsList, setFaqsList] = useState([]);
  // ── Field states ──
  const [question, setQuestion] = useState("");
  const [answer, setAnswer] = useState("");
  const [status, setStatus] = useState("active");
  const [faqfor, setFaqFor] = useState("customer");

  // ── ID for update/delete ──
  const [idToUpdateDeleteFaq, setIdToUpdateDeleteFaq] = useState("");

  // ══════════════════════════════════════════════════════════════════════
  // VIEW ALL FAQs
  // ══════════════════════════════════════════════════════════════════════
  const viewAllFaqs = () => {
    setLoading(true);
    axios
      .get(`${baseUrl}/admin/faqs/viewAllFaqs`, {
        headers: { Authorization: `Bearer ${authToken}` },
      })
      .then((response) => {
        console.log("FAQs response:", response.data);
        console.log("First FAQ fields:", response.data.faqs?.[0]);
        if (response.data.success == true) {
          setFaqsList(response.data.faqs);
        } else {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: response.data.message,
          });
        }
        setLoading(false);
      })
      .catch((error) => {
        console.log("FAQs error:", error);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Failed to load FAQs.",
        });
        setLoading(false);
      });
  };

  useEffect(() => {
    if (!authToken) {
      setLoading(false);
      navigate("/admin/login");
      return;
    }
    viewAllFaqs();
  }, [authToken]);

  // ══════════════════════════════════════════════════════════════════════
  // ADD FAQ
  // ══════════════════════════════════════════════════════════════════════
  const addFaq = () => {
    const formData = new FormData();
    formData.append("question", question);
    formData.append("answer", answer);
    formData.append("status", status);
    formData.append("faqfor", faqfor);

    axios
      .post(`${baseUrl}/admin/faqs/addFaq`, formData, {
        headers: { "Content-Type": "multipart/form-data", Authorization: `Bearer ${authToken}` },
      })
      .then((response) => {
        console.log("Add FAQ response:", response.data);
        if (response.data.hasOwnProperty("error")) {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: response.data.message,
          });
         
        } else {
           Swal.fire({
            icon: "success",
            title: "Success",
            text: response.data.message,
          });
          setShowCreateModal(false);
          viewAllFaqs();
          
        }
      })
      .catch((error) => {
        console.log("Add FAQ error:", error);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Failed to add FAQ.",
        });
      });
  };

  // ══════════════════════════════════════════════════════════════════════
  // UPDATE FAQ
  // ══════════════════════════════════════════════════════════════════════
  const updateFaq = () => {
    const formData = new FormData();
    formData.append("id", idToUpdateDeleteFaq);
    formData.append("question", question);
    formData.append("answer", answer);
    formData.append("status", status ? 1 : 0);
    formData.append("faqfor", faqfor);

    axios
      .post(`${baseUrl}/admin/faqs/updateFaq`, formData, {
        headers: { "Content-Type": "multipart/form-data", Authorization: `Bearer ${authToken}` },
      })
      .then((response) => {
        console.log("Update FAQ response:", response.data);
        if (response.data.hasOwnProperty("error")) {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: response.data.message,
          });
        } else {
          Swal.fire({
            icon: "success",
            title: "Success",
            text: response.data.message,
          });
          setShowCreateModal(false);
          viewAllFaqs();
        } 
      })
      .catch((error) => {
        console.log("Update FAQ error:", error);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Failed to update FAQ.",
        });
      });
  };

  // ══════════════════════════════════════════════════════════════════════
  // TOGGLE STATUS
  // ══════════════════════════════════════════════════════════════════════
  const toggleFaqStatus = (id) => {
    // sirf id bhejna hai — backend khud active/inactive toggle karega
    const formData = new FormData();
    formData.append("id", id);

    axios
      .post(`${baseUrl}/admin/faqs/updateFaqStatus`, formData, {
        headers: { "Content-Type": "multipart/form-data", Authorization: `Bearer ${authToken}` },
      })
      .then((response) => {
        console.log("Toggle status response:", response.data);
        if (response.data.hasOwnProperty("error")) {
           Swal.fire({
            icon: "error",
            title: "Error",
            text: response.data.message,
          });
         
        } else {
          viewAllFaqs();
        }
      })
      .catch((error) => {
        console.log("Toggle status error:", error);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Failed to update status.",
        });
      });
  };

  // ══════════════════════════════════════════════════════════════════════
  // DELETE FAQ
  // ══════════════════════════════════════════════════════════════════════
  const deleteFaq = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "This FAQ will be permanently deleted!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#6c757d",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        const formData = new FormData();
        formData.append("id", idToUpdateDeleteFaq);

        axios
          .post(`${baseUrl}/admin/faqs/deleteFaq`, formData, {
            headers: { "Content-Type": "multipart/form-data", Authorization: `Bearer ${authToken}` },
          })
          .then((response) => {
            console.log("Delete FAQ response:", response.data);
            if (response.data.hasOwnProperty("error")) {
              Swal.fire({
                icon: "error",
                title: "Error",
                text: response.data.message,
              });
            } else {
              Swal.fire({
                icon: "success",
                title: "Deleted!",
                text: response.data.message,
              });
              viewAllFaqs();
            } 
          })
          .catch((error) => {
            console.log("Delete FAQ error:", error);
            Swal.fire({
              icon: "error",
              title: "Error",
              text: "Failed to delete FAQ.",
            });
          });
      }
    });
  };

  // ── Stats ──
  const statsData = [
    {
      icon: FaQuestionCircle,
      iconBg: "linear-gradient(135deg, #e3f2fd, #bbdefb)",
      iconColor: "#2196f3",
      label: "Total FAQs",
      value: faqsList.length.toString(),
      badge: "+6",
    },
    {
      icon: FaCheckCircle,
      iconBg: "linear-gradient(135deg, #e8f5f0, #d4ede3)",
      iconColor: "#0ac46c",
      label: "Active FAQs",
      value: faqsList.filter((f) => f.status === "active").length.toString(),
      badge: "Live",
    },
    {
      icon: FaTimesCircle,
      iconBg: "linear-gradient(135deg, #ffebee, #ffcdd2)",
      iconColor: "#f44336",
      label: "Inactive FAQs",
      value: faqsList.filter((f) => f.status === "inactive").length.toString(),
      badge: "Hidden",
    },
  ];

  // ── Filter ──
  const filteredFAQs = faqsList.filter((faq) => {
    if (!searchTerm) return true;
    const q = (faq.question || "").toLowerCase();
    const a = (faq.answer || "").toLowerCase();
    const term = searchTerm.toLowerCase();
    return q.includes(term) || a.includes(term);
  });

  // ── Actions ──
  const getActions = (faq) => [
    {
      icon: "MdVisibility",
      label: "View Details",
      onClick: () => {
        setSelectedFAQ(faq);
        setShowViewModal(true);
      },
    },
    {
      icon: "MdEdit",
      label: "Edit FAQ",
      onClick: () => {
        setIsEditing(true);
        setIdToUpdateDeleteFaq(faq.id);
        setQuestion(faq.question);
        setAnswer(faq.answer);
        setStatus(faq.status);
        setFaqFor(faq.faqfor);
        setShowCreateModal(true);
      },
    },
    {
      icon: faq.status === "active" ? "MdToggleOff" : "MdToggleOn",
      label: faq.status === "active" ? "Inactive" : "Active",
      onClick: () => toggleFaqStatus(faq.id),
    },
    {
      icon: "MdDelete",
      label: "Delete",
      onClick: () => {
        setIdToUpdateDeleteFaq(faq.id);
        deleteFaq();
      },
      className: "danger",
    },
  ];

  // ════════════════════════════════════════════════════════════════════
  // RENDER
  // ════════════════════════════════════════════════════════════════════
  if (loading) {
    return (
      <AdminLayout>
        <FAQsSkeleton />
      </AdminLayout>
    );
  }

  return (
    <AdminLayout>
      <div>
        {/* ── Page Header ── */}
        <div className="ksa-faq-page-header">
          <div>
            <h1 className="ksa-layout-page-title">FAQ Management</h1>
            <p className="ksa-layout-page-subtitle">
              Manage frequently asked questions to help your customers.
            </p>
          </div>
          <Button
            variant="primary"
            size="medium"
            icon={<FaPlus />}
            iconPosition="left"
            onClick={() => {
              setIsEditing(false);
              setQuestion("");
              setAnswer("");
              setStatus("active");
              setFaqFor("customer");
              setShowCreateModal(true);
            }}
          >
            Add New FAQ
          </Button>
        </div>

        {/* ── Stats Cards ── */}
        <Row className="g-4 mb-4 ksa-faq-stats">
          {statsData.map((stat, idx) => (
            <Col key={idx} xs={12} sm={6} lg={4}>
              <StatCard {...stat} />
            </Col>
          ))}
        </Row>

        {/* ── Main Table ── */}
        <div className="ksa-card">
          <div className="ksa-faq-table-header">
            <div className="ksa-faq-search">
              <FaSearch size={16} />
              <input
                type="text"
                placeholder="Search FAQs by question, answer"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
          </div>

          {/* Table */}
          <div className="ksa-faq-table-wrapper">
          <table className="ksa-faq-table">
              <thead>
                <tr>
                  <th>QUESTION</th>
                  <th>ANSWER</th>
                  <th>FOR</th>
                  <th>STATUS</th>
                  <th>ACTIONS</th>
                </tr>
              </thead>
              <tbody>
                {filteredFAQs
                  .slice(
                    (currentPage - 1) * itemsPerPage,
                    currentPage * itemsPerPage,
                  )
                  .map((faq) => (
                    <tr key={faq.id}>
                      <td className="ksa-faq-question">{faq.question}</td>
                      <td>{faq.answer}</td>
                      <td style={{ textTransform: "capitalize" }}>
                        {faq.faqfor}
                      </td>
                      <td>
                        <span
                          style={{
                            display: "inline-block",
                            padding: "3px 12px",
                            borderRadius: "20px",
                            fontSize: "12px",
                            fontWeight: "600",
                            backgroundColor:
                              faq.status === "active" ? "#e8f5f0" : "#ffebee",
                            color:
                              faq.status === "active" ? "#0ac46c" : "#f44336",
                          }}
                        >
                          {faq.status === "active" ? "Active" : "Inactive"}
                        </span>
                      </td>
                      <td>
                        <ActionDropdown actions={getActions(faq)} />
                      </td>
                    </tr>
                  ))}

                {/* Koi FAQ nahi ── */}
                {filteredFAQs.length === 0 && (
                  <tr>
                    <td
                      colSpan={4}
                      style={{ textAlign: "center", padding: "20px" }}
                    >
                      No FAQs found.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          <Pagination
            totalItems={filteredFAQs.length}
            itemsPerPage={itemsPerPage}
            currentPage={currentPage}
            onPageChange={setCurrentPage}
            onItemsPerPageChange={setItemsPerPage}
          />
        </div>

        {/* ── Add/Edit Modal ── */}
        {showCreateModal && (
          <div
            className="ksa-modal-overlay"
            onClick={() => setShowCreateModal(false)}
          >
            <div
              className="ksa-modal ksa-modal-lg ksa-faq-modal"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="ksa-faq-modal-header">
                <h3 className="ksa-faq-modal-title">
                  {isEditing ? "Edit FAQ" : "Add New FAQ"}
                </h3>
                <button
                  className="ksa-modal-close"
                  onClick={() => setShowCreateModal(false)}
                >
                  <FaTimes size={18} />
                </button>
              </div>

              <div className="ksa-faq-modal-body">
                <div className="ksa-faq-form-group">
                  <label>Question *</label>
                  <input
                    type="text"
                    className="ksa-faq-input"
                    placeholder="e.g., How do I place an order?"
                    value={question}
                    onChange={(e) => setQuestion(e.target.value)}
                  />
                </div>
                <div className="ksa-faq-form-group">
                  <label>Answer *</label>
                  <textarea
                    className="ksa-faq-textarea"
                    placeholder="Provide a detailed answer..."
                    value={answer}
                    onChange={(e) => setAnswer(e.target.value)}
                    rows="6"
                  />
                </div>
                <div className="ksa-faq-form-group">
                  <label>For *</label>
                  <select
                    className="ksa-faq-input"
                    value={faqfor}
                    onChange={(e) => setFaqFor(e.target.value)}
                  >
                    <option value="customer">Customer</option>
                    <option value="seller">Seller</option>
                    <option value="delivery">Delivery</option>
                  </select>
                </div>
              </div>

              <div className="ksa-faq-modal-footer">
                <Button
                  variant="secondary"
                  onClick={() => setShowCreateModal(false)}
                >
                  Cancel
                </Button>
                <Button
                  variant="primary"
                  onClick={isEditing ? updateFaq : addFaq}
                >
                  {isEditing ? "Update FAQ" : "Create FAQ"}
                </Button>
              </div>
            </div>
          </div>
        )}

        {/* ── View Modal ── */}
        {showViewModal && selectedFAQ && (
          <div
            className="ksa-modal-overlay"
            onClick={() => setShowViewModal(false)}
          >
            <div
              className="ksa-modal ksa-modal-md ksa-faq-view-modal"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="ksa-faq-modal-header">
                <h3 className="ksa-faq-modal-title">FAQ Details</h3>
                <button
                  className="ksa-modal-close"
                  onClick={() => setShowViewModal(false)}
                >
                  <FaTimes size={18} />
                </button>
              </div>

              <div className="ksa-faq-modal-body">
                <div className="ksa-faq-detail-item">
                  <label>Question</label>
                  <p>{selectedFAQ.question}</p>
                </div>
                <div className="ksa-faq-detail-item">
                  <label>Answer</label>
                  <p>{selectedFAQ.answer}</p>
                </div>
                <Row className="g-3">
                  <Col xs={6}>
                    <div className="ksa-faq-detail-item">
                      <label>For</label>
                      <p style={{ textTransform: "capitalize" }}>
                        {selectedFAQ.faqfor}
                      </p>
                    </div>
                  </Col>
                  <Col xs={6}>
                    <div className="ksa-faq-detail-item">
                      <label>Status</label>
                      <p>
                        <span
                          className={`ksa-faq-status ksa-faq-status-${selectedFAQ.status === "active" ? "active" : "inactive"}`}
                        >
                          {selectedFAQ.status === "active"
                            ? "Active"
                            : "Inactive"}
                        </span>
                      </p>
                    </div>
                  </Col>
                </Row>
              </div>

              <div className="ksa-faq-modal-footer">
                <Button
                  variant="secondary"
                  onClick={() => setShowViewModal(false)}
                >
                  Close
                </Button>
                <Button
                  variant="primary"
                  onClick={() => {
                    setShowViewModal(false);
                    setIsEditing(true);
                    setIdToUpdateDeleteFaq(selectedFAQ.id);
                    setQuestion(selectedFAQ.question);
                    setAnswer(selectedFAQ.answer);
                    setStatus(selectedFAQ.status);
                    setFaqFor(selectedFAQ.faqfor);
                    setShowCreateModal(true);
                  }}
                >
                  Edit FAQ
                </Button>
              </div>
            </div>
          </div>
        )}
      </div>
    </AdminLayout>
  );
};

export default FAQs;
